import { render, staticRenderFns } from "./EditPersonalPoint.vue?vue&type=template&id=73529d58&"
import script from "./EditPersonalPoint.vue?vue&type=script&lang=js&"
export * from "./EditPersonalPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports